import formErrors from '../../support/formErrors';

export default (
    states,
    currentPackage,
    ship,
    requiresAddress,
    tangible,
    requiresPlayerName,
    requiresPlayerNumber,
    requiresMultiplePhotos,
    packageRequirementPhotos,
    playerName,
    playerNumber,
    customerId,
) => ({
    imageId: null,
    currentPackage,
    urlParams: {},
    ship,
    requiresAddress,
    tangible,
    requiresPlayerName,
    requiresPlayerNumber,
    requiresMultiplePhotos:
        Alpine.$persist(requiresMultiplePhotos).as('requires-multiple-photos-' + customerId) ??
        false,
    packageRequirementPhotos:
        Alpine.$persist(packageRequirementPhotos).as('package-requirement-photos-' + customerId) ??
        {},
    customerId,
    playerName: Alpine.$persist(playerName).as('player-name-' + customerId) ?? '',
    playerNumber: Alpine.$persist(playerNumber).as('player-number-' + customerId) ?? '',
    isShipOnly: Alpine.$persist(false).as('is-ship-only'),
    states,

    init() {
        this.$watch('playerName', (value) => (!value?.trim() ? (this.playerName = '') : ''));
        this.$watch('playerNumber', (value) => (!value?.trim() ? (this.playerNumber = '') : ''));

        window.addEventListener('quick-checkout::update-package-photos', () => {
            this.requiresMultiplePhotos = this.$wire.get('requiresMultiplePhotos');
            this.packageRequirementPhotos = this.$wire.get('packageRequirementPhotos');
        });
    },

    initializeProps({ detail }) {
        this.imageId = detail.imageId;
        this.urlParams = detail.urlParams;
        this.currentPackage = detail.package;
        this.requiresAddress = this.currentPackage.requires_address;
        this.tangible = this.currentPackage.tangible;

        if (this.$store.cart.mainEvent?.id) {
            this.isShipOnly = this.$store.cart.mainEvent.delivery_type === 'Ship Only';
        }

        if (this.isShipOnly && (this.requiresAddress || this.tangible)) {
            this.ship = true;
        }

        if (!this.currentPackage.hide_player_name) {
            this.requiresPlayerName = true;
        }

        if (!this.currentPackage.hide_player_number) {
            this.requiresPlayerNumber = true;
        }
    },

    flag(item) {
        return !item.is_digital && !item.shipping_price ? 'Free Shipping!' : null;
    },

    stateAbbreviation(state) {
        for (var key in this.states) {
            this.states[this.states[key]] = key;
        }

        return this.states[state] ?? state;
    },

    ...formErrors,
});
